import React from "react";
import { TextInput, View } from "react-native";
import { useBiblo } from "../../hooks/Biblo.hook";
import { Typography, TypographySize } from "../Typography.component";
import { IndexHeaderTags } from "./IndexHeaderTags.component";
import { getTextStyles, getViewStyles } from "../../helpers/getStyles.helper";
import { ErrorBoundary } from "../ErrorBoundary.component";
export const IndexHeader = () => {
  const {
    indexOptions,
    searchValue,
    setSearchValue,
    defaultStyles,
    disableDefaultStyles: disableDefaultStylesGlobal
  } = useBiblo();
  const disableDefaultStyles = disableDefaultStylesGlobal || indexOptions.disableDefaultStyles;
  const titleString = typeof indexOptions.headerTitle === "string" ? indexOptions.headerTitle : "";
  const placeholderString = indexOptions.headerSearchPlaceholder || "Type to search";
  const Container = indexOptions.headerComponent || View;
  const Title = indexOptions.headerTitleComponent || View;
  const Search = indexOptions.headerSearchComponent || View;
  return /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "headerComponent"
  }, /*#__PURE__*/React.createElement(Container, {
    title: titleString,
    style: getViewStyles(indexOptions.headerStyle, {
      paddingVertical: defaultStyles.spacing
    }, disableDefaultStyles)
  }, titleString !== "" && /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "headerTitle"
  }, /*#__PURE__*/React.createElement(Title, {
    title: titleString,
    style: getViewStyles(indexOptions.headerTitleStyle, {
      paddingHorizontal: defaultStyles.spacing
    }, disableDefaultStyles),
    textStyle: indexOptions.headerTitleTextStyle
  }, /*#__PURE__*/React.createElement(Typography, {
    bold: true,
    size: TypographySize.Large,
    style: indexOptions.headerTitleTextStyle,
    disableDefaultStyles: disableDefaultStyles
  }, titleString))), indexOptions.headerSearchHidden || /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "headerSearchComponent"
  }, /*#__PURE__*/React.createElement(Search, {
    value: searchValue,
    onChangeText: setSearchValue,
    placeholder: placeholderString,
    style: getViewStyles(indexOptions.headerSearchStyle, {
      marginTop: titleString === "" ? 0 : defaultStyles.spacing,
      paddingHorizontal: defaultStyles.spacing
    }, disableDefaultStyles),
    inputStyle: indexOptions.headerSearchInputStyle
  }, /*#__PURE__*/React.createElement(TextInput, {
    placeholder: placeholderString,
    value: searchValue,
    onChangeText: setSearchValue,
    returnKeyType: "search",
    style: getTextStyles(indexOptions.headerSearchInputStyle, defaultStyles.textInput, disableDefaultStyles)
  }))), indexOptions.headerTagsHidden || /*#__PURE__*/React.createElement(ErrorBoundary, {
    type: "headerTagsComponent"
  }, /*#__PURE__*/React.createElement(IndexHeaderTags, null))));
};
//# sourceMappingURL=IndexHeader.component.js.map